<figure class="flex h-full flex-col gap-2">
  <figcaption class="text-muted-foreground text-xs font-medium tracking-wide uppercase">
    {{ caption() }}
  </figcaption>

  <p class="sr-only">{{ description() }}</p>

  <!-- Browser window sketch -->
  <div
    class="bg-background relative flex flex-1 flex-col overflow-hidden rounded-lg border shadow-sm"
    [class.min-h-64]="!compact()"
    [class.min-h-32]="compact()"
    aria-hidden="true">
    <div class="bg-muted/60 flex items-center gap-1 border-b px-2.5 py-2">
      <span class="bg-muted-foreground/30 size-1.5 rounded-full"></span>
      <span class="bg-muted-foreground/30 size-1.5 rounded-full"></span>
      <span class="bg-muted-foreground/30 size-1.5 rounded-full"></span>
      <span class="bg-muted-foreground/15 ms-2 h-2 flex-1 rounded-full"></span>
    </div>

    <div class="flex flex-1 flex-col gap-2 p-3">
      <span class="bg-muted-foreground/25 h-2.5 w-2/5 rounded-full"></span>
      <span class="bg-muted-foreground/15 h-1.5 w-full rounded-full"></span>
      @if (!compact()) {
        <span class="bg-muted-foreground/15 h-1.5 w-4/5 rounded-full"></span>
      }

      @if (variant() === 'inline') {
        <!-- The shop inside the page content: a card in the column, not edge to edge.
             A rough sketch of the enabled voucher kinds, not the plugin's real layout. -->
        <div
          class="bg-card mx-auto my-1 w-4/5 max-w-48 space-y-2 rounded-md border p-2.5 shadow-xs">
          <p class="truncate text-[11px] font-semibold">{{ shopTitle() }}</p>

          @if (showTabs()) {
            <!-- Value and product vouchers together: the plugin switches between them -->
            <div class="bg-muted flex gap-0.5 rounded p-0.5 text-[9px] font-medium">
              <span class="bg-background flex-1 rounded-sm py-0.5 text-center shadow-xs">Wert</span>
              <span class="text-muted-foreground flex-1 py-0.5 text-center">Produkt</span>
            </div>
          }

          @if (showMoney()) {
            @if (fixedAmounts()) {
              <div class="flex gap-1">
                @for (amount of [25, 50]; track amount) {
                  <span class="flex-1 rounded border py-1 text-center text-[10px] tabular-nums">
                    {{ amount }} €
                  </span>
                }
              </div>
            }
            @if (showFree()) {
              <span
                class="text-muted-foreground flex items-center justify-between rounded border px-1.5 py-1 text-[10px] tabular-nums">
                <span class="text-foreground">50</span>
                €
              </span>
            }
          } @else {
            <!-- Product vouchers only -->
            @for (product of [1, 2]; track product) {
              <div class="flex items-center gap-1.5">
                <span class="bg-muted size-4 shrink-0 rounded-sm"></span>
                <span class="bg-muted-foreground/20 h-1.5 flex-1 rounded-full"></span>
              </div>
            }
          }

          <span
            class="block rounded py-1.5 text-center text-[10px] font-semibold"
            [style.background-color]="background()"
            [style.color]="foreground()">
            Weiter
          </span>
        </div>
      }

      @if (!compact()) {
        <span class="bg-muted-foreground/15 h-1.5 w-full rounded-full"></span>
        <span class="bg-muted-foreground/15 h-1.5 w-3/5 rounded-full"></span>
      }
    </div>

    @if (variant() === 'widget') {
      <!-- The floating button, bottom right as the plugin places it -->
      <span
        class="absolute end-3 bottom-3 flex items-center gap-1 rounded-md px-2.5 py-1.5 text-[10px] font-semibold shadow-md"
        [style.background-color]="background()"
        [style.color]="foreground()">
        <ng-icon name="lucideGift" size="12" />
        Gutschein kaufen
      </span>
    }
  </div>
</figure>
